import { Component, inject, OnInit } from '@angular/core';
import { AppInformationService, AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { CustomerProductPriceOverride } from 'app/core/model/customer-product-price-override';
import { Product } from 'app/core/model/product';
import DataSource from 'devextreme/data/data_source';
import validationEngine from 'devextreme/ui/validation_engine';
import { Subject } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-customer-product-price-override-dialog',
    template: `
        <div class="modal-header">
            <h2 class="modal-title">{{ isNew ? 'Add' : 'Edit' }} Price Override</h2>
        </div>
        <div class="modal-body">
            <dx-form [formData]="customerProductPriceOverride" validationGroup="customerProductPriceOverrideValidationGroup">
                <dxi-item
                    dataField="productId"
                    editorType="dxSelectBox"
                    [label]="{ text: 'Product' }"
                    [editorOptions]="{ dataSource: productsDS, displayExpr: productDisplayExpr, searchExpr: ['partNumber', 'description'], valueExpr: 'id', searchEnabled: true }"
                    [isRequired]="true"
                ></dxi-item>
                <dxi-item dataField="price" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 } }" [isRequired]="true"> </dxi-item>
                <dxi-item dataField="endDate" editorType="dxDateBox" [label]="{ text: 'End Date' }" [editorOptions]="{ showClearButton: true }"></dxi-item>
            </dx-form>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="save()">Save</button>
            <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
        </div>
    `,
    styles: '',
})
export class CustomerProductPriceOverrideDialogComponent implements OnInit {
    uow = inject(BrewersUnitOfWork);
    auth = inject(AuthService);
    appInfo = inject(AppInformationService);

    result = new Subject<{ success: boolean; value?: CustomerProductPriceOverride }>();
    customerProductPriceOverride: CustomerProductPriceOverride;
    customerId: number;
    isNew: boolean;
    products: Product[];
    productsDS: DataSource;

    productDisplayExpr = (item: Product) => (item ? `${item.partNumber} - ${item.description}` : '');

    async ngOnInit() {
        this.productsDS = new DataSource({ store: this.products, paginate: true });

        if (!this.customerProductPriceOverride) {
            this.isNew = true;
            this.customerProductPriceOverride = this.uow.customerProductPriceOverrides.createEntity({
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
                customerId: this.customerId,
                price: null,
                productId: null,
                endDate: null,
            });
        }
    }

    async save() {
        const success = this.valid();
        if (!success) return;

        await this.appInfo.pleaseWaitShow();
        await this.uow.commit([this.customerProductPriceOverride]);
        await this.appInfo.pleaseWaitHide();

        this.result.next({ success: true, value: this.customerProductPriceOverride });
    }

    cancel() {
        this.customerProductPriceOverride.entityAspect.rejectChanges();

        this.result.next({ success: false });
    }

    valid() {
        const groupConfig = validationEngine.getGroupConfig('customerProductPriceOverrideValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('customerProductPriceOverrideValidationGroup');
            return result.isValid;
        } else return false;
    }
}
